import type { LogEvent, LogEventWithOptions, LogEvents, ReportLogEventsInput } from '../events';

import { filterNullishProperties } from './filterUndefinedEventPropertiesInput';
import { getApplicationContextInput } from './getApplicationContextInput';
import { getLogEventInput } from './getTelemetryEventInput';

type GetLogEventInputWithContext = (event: LogEvent) => Promise<LogEventWithOptions>;
export const getLogEventInputWithContext: GetLogEventInputWithContext = async (event) => {
  const { event: logEventInput, options } = await getLogEventInput(event);
  const {
    ClientId,
    first_party_client,
    client_load_id,
    client_load_time,
    yamjs_revision,
    environment,
    UserId,
    NetworkId,
  } = getApplicationContextInput();

  return {
    event: {
      ...logEventInput,
      ...(ClientId && { ClientId }),
      ...(UserId && { UserId: Number(UserId) }),
      ...(NetworkId && { NetworkId: Number(NetworkId) }),
      Parameters: filterNullishProperties({
        ...logEventInput.Parameters,
        first_party_client,
        client_load_id,
        client_load_time,
        yamjs_revision,
        environment,
      }),
    },
    options,
  };
};

type GetReportLogEventsInput = (logEvents: LogEvents) => Promise<ReportLogEventsInput>;
export const getReportLogEventsInput: GetReportLogEventsInput = async (logEvents) => {
  const { errorEvents, performanceEvents, infoEvents } = logEvents;

  return {
    errorEvents: await Promise.all(errorEvents.map((event) => getLogEventInputWithContext(event))),
    infoEvents: await Promise.all(infoEvents.map((event) => getLogEventInputWithContext(event))),
    performanceEvents: await Promise.all(performanceEvents.map((event) => getLogEventInputWithContext(event))),
  };
};
